<template>
  <div class="medicine-class-input-form">
    <div
      class="row medicine-large-class"
      v-if="
        target === 'medicine-medium-classes' ||
          target === 'medicine-small-classes'
      "
    >
      <select-box-text-form
        :label="'大分類名'"
        :maxlength="30"
        :placeholder="'30文字まで'"
        :requiredFlg="true"
        :selectData="largeClassesSelectData"
        :selectStyles="{ width: '200px' }"
        :selectValue="largeClass.id"
        :textDisabled="Boolean(largeClass.id)"
        :textStyles="{ width: '250px' }"
        :textValue="largeClass.name"
        @select-input="selectInput($event, 'largeClass')"
        @text-input="textInput($event, 'largeClass')"
        data-test="large-class-select-box-text-form"
      />
    </div>
    <div
      class="row medicine-medium-class"
      v-if="target === 'medicine-small-classes'"
    >
      <select-box-text-form
        :label="'中分類名'"
        :maxlength="30"
        :placeholder="'30文字まで'"
        :requiredFlg="true"
        :selectData="mediumClassesSelectData"
        :selectStyles="{ width: '200px' }"
        :selectValue="mediumClass.id"
        :textDisabled="Boolean(mediumClass.id)"
        :textStyles="{ width: '250px' }"
        :textValue="mediumClass.name"
        @select-input="selectInput($event, 'mediumClass')"
        @text-input="textInput($event, 'mediumClass')"
        data-test="medium-class-select-box-text-form"
      />
    </div>
    <div class="row name">
      <text-input-form
        :disabled="disabledNameEdit"
        :requiredFlg="true"
        :placeholder="`${maxlength}文字まで`"
        :maxlength="maxlength"
        :styles="{ width: '350px' }"
        v-model="editClass.name"
        >{{ fieldName }}</text-input-form
      >
    </div>
    <div class="row showFlg">
      <select-box-form
        :selectData="selectData"
        v-model.number="editClass.showFlg"
        >表示設定</select-box-form
      >
    </div>
  </div>
</template>

<script>
import TextInputForm from '@/components/parts/molecules/TextInputForm'
import SelectBoxForm from '@/components/parts/molecules/SelectBoxForm'
import SelectBoxTextForm from '@/components/parts/molecules/SelectBoxTextForm.vue'

export default {
  name: 'MedicineClassInputForm',

  components: {
    TextInputForm,
    SelectBoxForm,
    SelectBoxTextForm
  },

  props: {
    editClass: { type: Object },
    target: { type: String },
    largeClass: { type: Object, default: () => ({}) },
    largeClassesSelectData: { type: Array, default: () => [] },
    mediumClass: { type: Object, default: () => ({}) },
    mediumClassesSelectData: { type: Array, default: () => [] }
  },

  data() {
    return {
      selectData: [
        { id: 1, name: '〇' },
        { id: 0, name: '✕' }
      ]
    }
  },

  computed: {
    fieldName() {
      return this.target === 'medicine-large-classes'
        ? '大分類名'
        : this.target === 'medicine-medium-classes'
        ? '中分類名'
        : '小分類名'
    },
    maxlength() {
      return this.target === 'medicine-small-classes' ? 50 : 30
    },
    disabledNameEdit() {
      return (
        this.target === 'medicine-large-classes' &&
        this.editClass.defaultMedicineLargeClassId != 0
      )
    }
  },
  methods: {
    selectInput(val, field) {
      this.$emit('select-input', { val, field })
    },
    textInput(val, field) {
      this.$emit('text-input', { val, field })
    }
  }
}
</script>

<style lang="scss" scoped>
.medicine-class-input-form {
  > .row ~ .row {
    margin-top: 25px;
  }
}
</style>
